import { DashboardRule } from '@/optimizer';

export const deduplicateCustomerRules = (
    rules: DashboardRule[],
): DashboardRule[] => {
    const seen = new Set<string>();
    const uniqueRules: DashboardRule[] = [];

    for (const rule of rules) {
        const key = JSON.stringify({
            channel: rule.channel,
            type: rule.type,
            subtype: rule.subtype,
            value: rule.value,
        });

        if (!seen.has(key)) {
            seen.add(key);
            uniqueRules.push(rule);
        }
    }

    return uniqueRules;
};
